import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { formaTimeForTsToH, sprintf, formatScore } from 'utils/index';
import { useAtom } from 'jotai';
import {
  guildIdAtom,
  giftConfigAtom,
  selectUserDataAtom,
  coinConfigAtom,
  salaryConfigAtom,
  dateTypeAtom,
} from 'store';
import { membersDetailList } from 'api';
import { Popup } from 'react-vant';
import LevelRule from 'components/level-rule';
import { getLvFromFloat } from './data-details';
import { MembersDetailType } from 'api/type';
import { Card } from './data-details';
import { _T } from '@dana/components';

const HostCard: React.FC<{
  num: number;
  data: MembersDetailType;
  last: boolean;
  date: string;
  isCurrentDate: boolean;
}> = ({ num, last, data, date, isCurrentDate }) => {
  const [show, setShow] = useState(false);
  const [popup, setP] = useState(false);
  const [giftFlow] = useAtom(giftConfigAtom);
  const [coinFlow, setCoinFlow] = useAtom(coinConfigAtom);
  const [salaryFlow, setSalaryFlow] = useAtom(salaryConfigAtom);
  const [ruleType, setRuleType] = useState<'coin' | 'gift' | 'salary'>('coin');
  const [ruletitle, setRuleTitle] = useState('');
  const [progressV, setProgressV] = useState({
    value: 0,
    level: 0,
    nextValue: 0,
  });
  const [userInfo, setUserInfo] = useAtom(selectUserDataAtom);

  useEffect(() => {
    if (giftFlow) {
      setProgressV(getLvFromFloat(giftFlow, data.giftFlowTotal));
    }
  }, [giftFlow, date, data.giftFlowTotal]);

  const navigate = useNavigate();

  function goToTime() {
    setUserInfo({
      uid: data?.memberId,
      totalTime: data?.inVoiceTotal,
      day: data?.activeDayTotal,
      nickName: data?.nickName,
      avatar: data?.avatar,
      date,
      danaId: data?.danaId,
    });
    navigate('/time');
  }

  function changeRuleType(type: 'coin' | 'gift' | 'salary', title: string) {
    setRuleType(type);
    setRuleTitle(title);
    setP(true);
  }

  function getConfig() {
    return ruleType === 'coin' ? coinFlow : ruleType === 'gift' ? giftFlow : salaryFlow;
  }

  return (
    <div className="mt-[24px] relative">
      <Popup visible={popup} closeIconPosition="bottom">
        <div className="flex flex-col items-center">
          <LevelRule isCurrentDate={isCurrentDate} title={ruletitle} data={getConfig()}></LevelRule>
          <div
            onClick={() => setP(false)}
            className="w-[36px] h-[36px] bg-cover mt-[12px]"
            style={{ backgroundImage: `url(${require('asset/imgs/close.png')})` }}
          ></div>
        </div>
      </Popup>
      <div className="relative flex justify-start items-center">
        <div className="text-[#333] font-sans text-[14px] font-bold leading-[18px]" dir="auto">
          {num}
        </div>
        <div
          className="ml-[12px] w-[52px] h-[52px] rounded-full bg-cover"
          style={{
            backgroundImage: `url(${data.avatar})`,
          }}
        ></div>

        <div className="flex flex-col justify-start items-start ml-[12px]">
          <div
            className="text-[#333] font-sans text-[14px] font-bold leading-[18px] truncate w-[90px]"
            dir="auto"
          >
            {data.nickName}
          </div>
          <div
            className="text-[#B3B3B3] font-sans text-[14px] font-semibold leading-[18px]"
            dir="auto"
          >
            ID: {data.danaId}
          </div>
        </div>
        <div className="flex ml-[50px]">
          <div
            className="w-[16px] h-[13px] bg-cover"
            style={{
              backgroundImage: `url(${require('asset/imgs/coin.png')})`,
            }}
          ></div>
          <div className="text-[#6b6b6b] text-right font-sans text-[14px] font-bold leading-[18px] ml-[2px]">
            {formatScore(Math.trunc(data.giftFlowTotal / 10) / 10)}
          </div>
        </div>
        <div
          className="absolute right-[12px] top-[50%] transform translate-y-[-50%] w-[18px] h-[18px] bg-cover"
          onClick={() => setShow(!show)}
          style={{
            backgroundImage: show
              ? `url(${require('asset/imgs/hide.png')})`
              : `url(${require('asset/imgs/show.png')})`,
          }}
        ></div>
      </div>
      <div
        className={`overflow-hidden ml-[-12px] flex justify-start flex-col items-center transition-all duration-500 ease-in-out ${show ? 'h-[150px]' : 'h-0'}`}
      >
        <div className="mt-[12px] flex justify-between w-full px-[12px]">
          <Card
            name={_T('公会长提成')}
            value={data.masterDeduct ? data.masterDeduct : 0}
            isQ={true}
            qClick={() => changeRuleType('salary', _T('公会长提成'))}
          ></Card>
          <Card
            name={_T('钻石流水等级')}
            value={progressV.level || '0'}
          ></Card>
          <Card
            name={_T('钻石流水')}
            value={data.giftFlowTotal / 100}
            showArrow
            onClick={() => {
              setUserInfo({
                uid: data?.memberId,
                totalTime: data?.inVoiceTotal,
                day: data?.activeDayTotal,
                nickName: data?.nickName,
                avatar: data?.avatar,
                date,
                danaId: data?.danaId,
              });
              navigate('/diamond-reward');
            }}
          ></Card>
        </div>
        <div className="mt-[12px] flex justify-between w-full px-[12px]">
          {/* <Card
            name={isCurrentDate ? _T('预估钻石薪资') : _T('钻石薪资')}
            value={'$' + (memberData?.anchorCoinData?.anchorCoinSalary || 0)}
            isQ={true}
            // qClick={() => changeRuleType('gift', _T('钻石薪资'))}
            qClick={() => changeRuleType('coin', isCurrentDate ? _T('预估钻石薪资') : _T('钻石薪资'))}
          ></Card> */}
          <Card
            name={isCurrentDate ? _T('预估钻石薪资（$）') : _T('钻石薪资')}
            value={data.anchorCoinSalary ? '$' + data.anchorCoinSalary : 0}
            isQ={true}
            qClick={() => changeRuleType('coin', isCurrentDate ? _T('预估钻石薪资') : _T('钻石薪资'))}
          ></Card>
          <Card
            name={isCurrentDate ? _T('预估钻石薪资等级') : _T('钻石薪资等级')}
            value={data.coinSalaryLv}
          ></Card>
          <Card
            name={isCurrentDate ? _T('钻石余额') : _T('清空钻石数')}
            value={(data?.cleanCoin || 0) / 100}
          ></Card>
        </div>
        {/* <div className="mt-[12px] flex justify-between w-full px-[12px]">
          <Card
            name={_T('总薪资')}
            value={data.anchorTotalSalary ? '$' + data.anchorTotalSalary : 0}
          ></Card>
          <Card
            name={_T('金币薪资')}
            value={data.anchorGitFlowSalary ? '$' + data.anchorGitFlowSalary : 0}
          ></Card>
          <Card
            name={_T('钻石薪资')}
            value={isCurrentDate ? '~' : data.anchorCoinSalary ? '$' + data.anchorCoinSalary : 0}
          ></Card>
        </div>
        <div className="mt-[12px] flex justify-between w-full px-[12px]">
          <Card
            name={_T('金币薪资等级')}
            value={progressV.level}
            isQ={true}
            qClick={() => changeRuleType('gift', _T('收到的金币'))}
          ></Card>
          <Card
            name={_T('收到的金币')}
            value={data.giftFlowTotal / 100}
            isQ={true}
            qClick={() => changeRuleType('gift', _T('收到的金币'))}
          ></Card>
          <Card
            name={_T('公会长提成')}
            value={data.masterDeduct ? data.masterDeduct : 0}
            isQ={true}
            qClick={() => changeRuleType('salary', _T('公会长提成'))}
          ></Card>
        </div> */}
        {/* <div className="w-full mt-[12px] flex justify-between px-[12px]">
          <Card
            type={'big'}
            name={_T('钻石薪资等级')}
            value={isCurrentDate ? '~' : data.coinSalaryLv}
          ></Card>
          <Card
            type={'big'}
            name={_T('清空钻石数')}
            value={isCurrentDate ? '~' : data.cleanCoin}
          ></Card>
        </div> */}
      </div>
      <div className="mt-[12px] pl-[12px] pr-[42px] relative w-[327px] h-[38px] rounded-lg bg-[#F5F7F7] flex justify-between items-center">
        <div className="flex">
          <div className="text-[#16B28D] font-sans text-[12px] font-semibold" dir="ltr">
            {_T('总直播时长')}:&nbsp;
          </div>
          <div className="text-[#B3B3B3] font-sans text-[12px] font-semibold" dir="ltr">
            {sprintf(_T('{hour}小时'), {
              hour: formaTimeForTsToH(data?.inVoiceTotal),
            })}
          </div>
        </div>
        <div className="flex">
          <div className="text-[#16B28D] font-sans text-[12px] font-semibold" dir="ltr">
            {_T('>=2小时')}:&nbsp;
          </div>
          <div className="text-[#B3B3B3] font-sans text-[12px] font-semibold" dir="ltr">
            {sprintf(_T('{day}天'), { day: data.activeDayTotal || 0 })}
          </div>
        </div>
        <div className="w-[1px] h-[11px] bg-[#B3B3B3] absolute left-[46%] top-[50%] transfrom translate-x-[-50%] translate-y-[-50%]"></div>
        <div
          className="absolute w-[18px] h-[18px] top-[50%] transform translate-y-[-50%] right-[12px] bg-cover"
          onClick={goToTime}
          style={{
            backgroundImage: `url(${require('asset/imgs/right.png')})`,
          }}
        ></div>
      </div>
      {!last && (
        <div className="absolute w-[327px] h-px bg-[#E6E6E6] left-[50%] transform translate-x-[-52%] bottom-[-15px]"></div>
      )}
    </div>
  );
};

const HostDetails: React.FC<{
  date: string;
  isCurrentDate: boolean;
  data: any[];
}> = ({ date, isCurrentDate, data }) => {
  const [dateType] = useAtom(dateTypeAtom);

  const [list, setList] = useState<MembersDetailType[]>();

  // console.log('zeze', data)

  const [guildId] = useAtom(guildIdAtom);

  const fetchData = async () => {
    const res = await membersDetailList(guildId, date, dateType === 'HALF_MONTH');
    // data.giftFlowTotal / 100
    if (res) {
      setList(res.sort((a, b) => b.giftFlowTotal - a.giftFlowTotal));
    }
  };

  // useEffect(() => {
  //     fetchData()
  // }, [date])

  return (
    <div className="bg-white mb-[12px] rounded-lg pt-[12px] pl-[12px] mt-[12px] mx-auto w-[351px] pb-[12px]">
      <div
        className="text-[#333] font-sans text-[16px] font-bold leading-[20px] pr-[12px]"
        dir="auto"
      >
        {_T('数据细节')}
      </div>
      {data &&
        data.length > 0 &&
        data.map((item, index) => (
          <HostCard
            isCurrentDate={isCurrentDate}
            date={date}
            data={item}
            key={index}
            num={index + 1}
            last={data.length === index + 1}
          ></HostCard>
        ))}
    </div>
  );
};

export default HostDetails;
